export default __webpack_public_path__ + "static/media/zk_shield_gradient.a298054e.svg";